import dayjs from "dayjs";
import * as XLSX from "xlsx";

import type { Supplier, SupplierBalanceSummary } from "~/types/purchasing";

/**
 * Export the Proveedores list (with open accounts-payable balances) to an .xlsx
 * workbook. Amounts are written as raw numbers so Excel treats them numerically.
 */
export function exportSuppliersToExcel(
  suppliers: Supplier[],
  balances: Map<string, SupplierBalanceSummary>
) {
  const rows = suppliers.map((s) => {
    const bal = balances.get(s.id);
    return {
      Nombre: s.name,
      "Razón social": s.razon_social ?? "",
      RUT: s.rut ?? "",
      "Código Softland": s.softland_code ?? "",
      Origen: s.is_foreign ? "Extranjero" : "Nacional",
      "Cuenta contable": s.ap_account_code ?? "",
      "Condición de pago": s.payment_condition ?? "",
      Banco: s.bank_name ?? "",
      "Cuenta bancaria": s.bank_account ?? "",
      Contacto: s.contact_name ?? "",
      Email: s.email ?? "",
      Teléfono: s.phone ?? "",
      Comuna: s.comuna ?? "",
      "Saldo abierto (CLP)": bal ? Number(bal.saldo_total) : 0,
      "Vencido (CLP)": bal ? Number(bal.overdue_amount) : 0,
      "Documentos abiertos": bal ? Number(bal.open_docs_count) : 0,
      Estado: s.is_active ? "Activo" : "Inactivo",
    };
  });

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(rows);
  ws["!cols"] = [
    { wch: 42 }, { wch: 42 }, { wch: 14 }, { wch: 16 }, { wch: 12 },
    { wch: 14 }, { wch: 20 }, { wch: 24 }, { wch: 18 }, { wch: 22 },
    { wch: 28 }, { wch: 16 }, { wch: 18 }, { wch: 18 }, { wch: 16 },
    { wch: 18 }, { wch: 10 },
  ];
  XLSX.utils.book_append_sheet(wb, ws, "Proveedores");
  XLSX.writeFile(wb, `Proveedores_${dayjs().format("YYYY-MM-DD")}.xlsx`);
}
